import React from 'react'

const EtUpdateSponsorUserPad = () => {
  return (
    <div>EtUpdateSponsorUserPad</div>
  )
}

export default EtUpdateSponsorUserPad